/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, leftValue: NonNullable<unknown>, rightChain: NonNullable<unknown>, rightValue: NonNullable<unknown> }} Chain_Page_Compare_Consensus_DifferentInputs */



/**
* | output |
* | --- |
* | "{leftChain} is {leftValue}, while {rightChain} is {rightValue}" |
*
* @param {Chain_Page_Compare_Consensus_DifferentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_consensus_different = /** @type {((inputs: Chain_Page_Compare_Consensus_DifferentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Consensus_DifferentInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.leftChain} is ${i?.leftValue}, while ${i?.rightChain} is ${i?.rightValue}`)
});